/*=========================================================================================
  File Name: moduleAccountsActions.js
  Description: Accounts Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axiosInstance from "../../libs/axios"

export default {

    getRoles({dispatch, commit}) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/accounts/roles").then((response) => {
                commit("SET_ROLES", response.data);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    registerAccount({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.post("/accounts/register", payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getAccounts({dispatch, commit}, payload) {
        let params = "";
        params += payload.skip !== undefined ? "skip=" + payload.skip : "";
        for (let i = 0; i < payload["roles"].length; i++) {
            params += "&roles=" + payload["roles"][i] + "&"
        }
        params += payload.sortBy ? "orderByDesc=" + payload.sortBy : "";
        params += payload.selectedGroupBy ? "&byInstitutions=" + payload.selectedGroupBy : "";
        params += payload.selectedType ? "&selectedType=" + payload.selectedType : "";
        if (payload.searchWord && payload.searchWord.length !== 0) {
            params += "&searchWord=" + payload.searchWord;
        }
        return new Promise((resolve, reject) => {
            axiosInstance.get("/accounts?" + params)
                .then((response) => {
                    commit("SET_ACCOUNTS", response.data.data);
                    commit("SET_ACCOUNTS_META", response.data.meta);
                    resolve(response.data.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getAccount({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/accounts/" + payload.id).then((response) => {
                commit("SET_ACCOUNT", response.data);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    updateAccount({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.put("/accounts/" + payload.id, payload).then((response) => {
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    changePassword({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.put("/accounts/change_password", payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    resetPassword({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.put(`/accounts/${payload.id}/actions/reset_password`, payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getRiskGroups({dispatch, commit}, payload) {

        return new Promise((resolve, reject) => {
            axiosInstance.get("/patients/patient_types/risk_group/patients?", payload).then((response) => {
                commit("SET_RISK_GROUPS", response.data.data);
                commit("SET_RISK_GROUPS_META", response.data.meta);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    deleteAccount({dispatch, commit}, payload) {

        return new Promise((resolve, reject) => {
            axiosInstance.delete("/accounts/" + payload.id).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    // Content-Type: 'application/octet-stream; charset=utf-8'
    exportIndexPatients({dispatch, commit}) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/export/patients/patient_types/index", {
                responseType: "blob",
                timeout: 30000
            })
                .then((response) => {
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    // exportIndexPatients({}){},
    exportContacts({}) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/export/patients/patient_types/contacts", {
                responseType: "blob",
                timeout: 30000
            })
                .then((response) => {
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    exportRiskGroups({}) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/export/patients/patient_types/riskgroups", {
                responseType: "blob",
                timeout: 30000
            })
                .then((response) => {
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
}
